class ProductDetailsTabs extends HTMLElement {
  connectedCallback() {
    if (this.isConnectedAndReady) return;
    this.isConnectedAndReady = true;
    this.tabs = [...this.querySelectorAll('[role="tab"]')];
    this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
    this.addEventListener('click', this.handleClick);
    this.addEventListener('keydown', this.handleKeydown);
  }

  disconnectedCallback() {
    this.isConnectedAndReady = false;
    this.removeEventListener('click', this.handleClick);
    this.removeEventListener('keydown', this.handleKeydown);
  }

  handleClick = (event) => {
    const tab = event.target.closest('[role="tab"]');
    if (!(tab instanceof HTMLButtonElement) || !this.contains(tab)) return;
    this.selectTab(tab, false);
  };

  handleKeydown = (event) => {
    const tab = event.target.closest('[role="tab"]');
    if (!(tab instanceof HTMLButtonElement) || !this.contains(tab)) return;

    const index = this.tabs.indexOf(tab);
    let nextIndex = index;

    if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
    else if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
    else if (event.key === 'Home') nextIndex = 0;
    else if (event.key === 'End') nextIndex = this.tabs.length - 1;
    else if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.selectTab(tab, false);
      return;
    } else return;

    event.preventDefault();
    this.selectTab(this.tabs[nextIndex], true);
  };

  selectTab(tab, moveFocus) {
    const panelId = tab.getAttribute('aria-controls');

    for (const candidate of this.tabs) {
      const selected = candidate === tab;
      candidate.setAttribute('aria-selected', String(selected));
      candidate.tabIndex = selected ? 0 : -1;
    }

    for (const panel of this.panels) panel.hidden = panel.id !== panelId;
    if (moveFocus) tab.focus({ preventScroll: true });
  }
}

if (!customElements.get('product-details-tabs')) {
  customElements.define('product-details-tabs', ProductDetailsTabs);
}
